// extracted by mini-css-extract-plugin
export default {"wrapper":"Header-module__wrapper","circle":"Header-module__circle","text":"Header-module__text","isHistory":"Header-module__isHistory"};